"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetSimulationStatuses = exports.useGetSimulations = void 0;

var _react = require("react");

var _reactQuery = require("react-query");

var _simulitas = require("../services/simulitas");

var _SimulitasException = require("../services/simulitas/SimulitasException");

var _useSimulator = require("./useSimulator");

var GetSimulationStatuses = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
  OUT_OF_RANGE_ERROR: 'OUT_OF_RANGE_ERROR'
};
exports.GetSimulationStatuses = GetSimulationStatuses;

var useGetSimulations = function useGetSimulations(productType, intendedCredit) {
  var fiveMinutesInMs = 300000;

  var _ref = (0, _react.useState)(GetSimulationStatuses.IDLE),
      _ref2 = _slicedToArray(_ref, 2),
      status = _ref2[0],
      setStatus = _ref2[1];

  var _ref3 = (0, _useSimulator.useSimulator)(),
      interestRateType = _ref3.interestRateType;

  var _ref4 = (0, _reactQuery.useQuery)(['getSimulations', productType, intendedCredit], function () {
    return (0, _simulitas.simulitasService)().getSimulations({
      productType: productType,
      intendedCredit: intendedCredit,
      interestRateType: interestRateType
    });
  }, {
    staleTime: fiveMinutesInMs,
    retry: function retry(failureCount, responseError) {
      if (failureCount >= 2) return false;
      if (responseError instanceof _SimulitasException.SimulitasException) return !responseError.isOutOfRangeError;
      return true;
    },
    refetchOnWindowFocus: false
  }),
      isLoading = _ref4.isLoading,
      isError = _ref4.isError,
      isSuccess = _ref4.isSuccess,
      error = _ref4.error,
      data = _ref4.data,
      refetch = _ref4.refetch;

  (0, _react.useEffect)(function () {
    if (isLoading) {
      setStatus(GetSimulationStatuses.LOADING);
    } else if (isSuccess) {
      setStatus(GetSimulationStatuses.SUCCESS);
    } else if (isError && error.isUnexpectedError) {
      setStatus(GetSimulationStatuses.UNEXPECTED_ERROR);
    } else if (isError && error.isOutOfRangeError) {
      setStatus(GetSimulationStatuses.OUT_OF_RANGE_ERROR);
    } else {
      setStatus(GetSimulationStatuses.IDLE);
    }
  }, [isLoading, isError, isSuccess, error]);
  return {
    status: status,
    error: error,
    data: data,
    refetch: refetch
  };
};

exports.useGetSimulations = useGetSimulations;